import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";

class Card extends React.Component {
  constructor(props) {
    super(props);
    this.buildIcon = this.buildIcon.bind(this);
    this.displayButtons = this.displayButtons.bind(this);
    this.clicked = this.clicked.bind(this);
  }

  buildIcon() {
    if (this.props.algorithm) {
      const brain = require("../thumb/brain.png");
      return <img className="brain" src={brain} alt="eh" />;
    } else {
      return (
        <span
          className="bullet"
          style={{ backgroundColor: this.props.color }}
        ></span>
      );
    }
  }

  displayButtons() {
    if (this.props.buttonTitle) {
      let buttonClass = (this.props.group === "tools" && this.props.buttonTitle === "Start tool") ? " tool" : "";
      const document = require("../thumb/Document.png");
      const image =
        this.props.buttonTitle === "Read" || this.props.buttonTitle === "View"
          ? document
          : this.props.buttonImage;

      return (
        <a
          className="btn btn-primary float-right"
          style={{ backgroundColor: this.props.color }}
          onClick={this.clicked}
        >
          <img className={"button-img" + buttonClass} src={image}></img>
          <div className="button-title">{this.props.buttonTitle}</div>
        </a>
      );
    }
    return null;
  }

  clicked() {
    if (this.props.pdf) {
      this.props.handleButton(this.props.pdf);
    } else if (this.props.href) {
      window.open(this.props.href, "_blank");
    } else {
      this.props.makeSelection(this.props.category, this.props.title);
    }
  }

  render() {
    const cardClass = "card " + this.props.cardClass;
    const fClass = this.props.fClass ? this.props.fClass : "figure-l";

    return (
      <div>
        <div className={cardClass}>
          {this.props.image ? (
            <img
              className={"card-img card-img-top " + fClass}
              src={this.props.image}
            ></img>
          ) : null}

          <div className="card-body">
            {this.props.title ? (
              <div className="bp">
                {this.buildIcon()}
                <h5 className="card-title">{this.props.title}</h5>
              </div>
            ) : null}
            <p className="card-text">{this.props.text}</p>
            {this.displayButtons()}
          </div>
        </div>
      </div>
    );
  }
}

export default Card;
